<script lang="ts">
  import DistributorChoiceModal from "@retailer/svelte/CartWidget/DistributorChoiceModal.svelte";
  import type { PLDistributor, Product, ProductLine } from "@shared/types/ProductLine";

  export let distributor: PLDistributor;
  export let product: Product;
  export let productLine: ProductLine;

  let Cart: any = null;
  if (!Cart) {
    Cart = window["angularInjector"].get("Cart");
  }

  const selectDistributor = () => {
    // @ts-ignore
    window.svelteModal(DistributorChoiceModal, {
      product: product,
      productLine: productLine,
      Cart: Cart,
      saveCB: (newDistributor: any) => (distributor = newDistributor),
    });
  };
</script>

{#if distributor && distributor.name}
  <p data-testid="distributor-name">
    {distributor.name}
  </p>
{:else}
  <slot name="cta" {selectDistributor}>
    <em class="fizz-text-subdued">None selected</em><br />
    <a href="/" on:click|preventDefault={selectDistributor}>Select distributor</a>
  </slot>
{/if}
